import React, { Fragment } from 'react';
import { Section } from './ui/Section';
export function About() {
  const artists = ['Eagles', 'Creedence Clearwater Revival', 'Midland', 'Stevie Ray Vaughan', 'Johnny Cash', 'Chris Stapleton', 'Zac Brown Band', 'Alan Jackson', 'George Strait', 'John Mayer', 'John Denver', 'Lynyrd Skynyrd'];
  return <Section id="about" className="bg-tx-secondary border-y border-tx-border" data-id="element-10">
      <h2 className="text-5xl md:text-7xl text-tx-cream mb-12" data-id="element-11">
        About the <span className="text-tx-red" data-id="element-12">Band</span>
      </h2>

      {/* Band Photo — full width, horizontal */}
      <div className="relative group mb-16" data-id="element-13">
        <div className="absolute inset-0 bg-tx-red/20 translate-x-3 translate-y-3 md:translate-x-4 md:translate-y-4 border border-tx-red/30 transition-transform duration-500 group-hover:translate-x-5 group-hover:translate-y-5" data-id="element-14"></div>
        <div className="relative z-10 overflow-hidden border border-tx-border" data-id="element-15">
          <img src="https://cdn.magicpatterns.com/uploads/9UZLphrMtu7h6zDL4Xg1tY/texarkana-band.jpg" alt="Texarkana band members with guitars" className="w-full h-auto object-cover aspect-[16/8] group-hover:scale-[1.02] transition-transform duration-700" data-id="element-16" />
          <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-tx-primary/90 via-tx-primary/40 to-transparent" data-id="element-17">
            <p className="font-heading text-2xl md:text-3xl text-tx-cream tracking-widest" data-id="element-18">
              TEXARKANA
            </p>
          </div>
        </div>
      </div>

      {/* Bio + Setlist */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16" data-id="element-19">
        <div className="space-y-6 text-lg md:text-xl text-tx-cream/80 leading-relaxed" data-id="element-20">
          <p data-id="element-21">
            Born from the dust and neon of the Southern circuit, Texarkana is
            more than a cover band—we're a revival. We bring the gritty,
            soul-stirring spirit of country and southern rock legends to every
            stage we play.
          </p>
          <p data-id="element-22">
            Whether it's a packed honky-tonk on a Saturday night or a sprawling
            festival under the stars, we deliver high-energy, authentic
            performances that honor the roots of American music. No backing
            tracks, no gimmicks. Just real musicians playing real music.
          </p>
        </div>

        <div className="lg:border-l lg:border-tx-border lg:pl-12" data-id="element-23">
          <h3 className="text-2xl text-tx-gold mb-6 tracking-widest" data-id="element-24">
            THE SETLIST INCLUDES:
          </h3>
          <div className="font-heading text-xl md:text-2xl text-tx-cream/90 leading-loose tracking-wider" data-id="element-25">
            {artists.map((artist, index) => <Fragment key={artist} data-id="element-26">
                <span className="hover:text-tx-red transition-colors cursor-default" data-id="element-27">
                  {artist}
                </span>
                {index < artists.length - 1 && <span className="text-tx-border mx-3 font-body font-light" data-id="element-28">
                    /
                  </span>}
              </Fragment>)}
          </div>
        </div>
      </div>
    </Section>;
}